import { useEffect } from "react"
import { useNavigate, useLocation, Outlet } from "react-router"
import Container from "@mui/material/Container"
import HeaderPS from "./header"
import Years from "./years"

export const year = [2019, 2020, 2021, 2025]

export default function PastSpeakers() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const year = searchParams.get("year")

    if (year) navigate(`/past-speakers/${year}`, { replace: true })
  }, [navigate, location.search])

  return (
    <Container sx={{ py: { xs: 4, sm: 6 }, mb: { xs: 8, sm: 10 } }}>
      <HeaderPS />
      <Years sx={{ mt: 4 }} />
      <Outlet />
    </Container>
  )
}
